// Static content for the Milestone Preservatives landing page.
// Mock-only — no API calls required.

export const MEDIA = {
  hero_bg:
    "https://mppl-website-assets.s3.ap-south-1.amazonaws.com/hero_bg.png",
  synthetic_amber:
    "https://mppl-website-assets.s3.ap-south-1.amazonaws.com/synthetic_amber.png",
  natural_green:
    "https://mppl-website-assets.s3.ap-south-1.amazonaws.com/natural_green.png",
  sustainability_bg:
    "https://mppl-website-assets.s3.ap-south-1.amazonaws.com/sustainability_bg.png",
  lab_beakers:
    "https://mppl-website-assets.s3.ap-south-1.amazonaws.com/lab_beakers.jpeg",
  pharma_tablets:
    "https://mppl-website-assets.s3.ap-south-1.amazonaws.com/pharma_tablets.jpeg",
};

// Infrastructure / Facility gallery.
// PLACEHOLDER mode: `url: null` -> tile renders a typographic placeholder.
// To go live: replace `url: null` with the actual photograph URL — nothing else to change.
export const INFRASTRUCTURE = [
  {
    id: "plant",
    title: "Manufacturing Plant",
    caption: "Dahej, Gujarat · Operational since 2023\nVadodara, Gujarat · Operational since 1995",
    url: "https://mppl-website-assets.s3.ap-south-1.amazonaws.com/MPPL-Heading-Img.jpeg",
    span: "lg:col-span-7 lg:row-span-2",
    ratio: "aspect-[4/3] lg:aspect-auto lg:min-h-[320px]",
  },
  {
    id: "reactors",
    title: "Reactor Hall",
    caption: "Closed-loop stainless steel reactors",
    url: "https://mppl-website-assets.s3.ap-south-1.amazonaws.com/AKV05484.JPG",
    span: "lg:col-span-5",
    ratio: "aspect-[5/3]",
  },
  {
    id: "lab",
    title: "QC Laboratory",
    caption: "HPLC · GC · Karl-Fischer analytics",
    url: "https://mppl-website-assets.s3.ap-south-1.amazonaws.com/IMG_1440_web.jpg",
    span: "lg:col-span-5",
    ratio: "aspect-[5/3]",
  },
  {
    id: "tanks",
    title: "Storage & Despatch",
    caption: "Inert-blanketed bulk storage · traceable warehousing",
    url: "https://mppl-website-assets.s3.ap-south-1.amazonaws.com/warehouse-mppl.png",
    span: "lg:col-span-4",
    ratio: "aspect-[4/3]",
  },
  {
    id: "pilot-plant",
    title: "Pilot Plant",
    caption: "New product scale-up & production validation",
    url: "https://mppl-website-assets.s3.ap-south-1.amazonaws.com/mppl-pilot.jpeg",
    span: "lg:col-span-4",
    ratio: "aspect-[4/3]",
  },
  {
    id: "control",
    title: "Process Control Room",
    caption: "Real-time, continuous process monitoring",
    url: "https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?auto=format&fit=crop&w=1200&q=80",
    span: "lg:col-span-4",
    ratio: "aspect-[4/3]",
  },
];

export const NAV_ITEMS = [
  { id: "about", label: "About" },
  { id: "products", label: "Products" },
  { id: "industries", label: "Industries" },
  { id: "infrastructure", label: "Facility" },
  { id: "quality", label: "Quality" },
  { id: "sustainability", label: "Clean Chemistry" },
  { id: "contact", label: "Contact" },
];

export const STATS = [
  { value: "25+", label: "Years in specialty chemistry" },
  { value: "ZLD", label: "Zero Liquid Discharge facility" },
  { value: "50+", label: "Countries served" },
  { value: "8", label: "Antioxidant product lines" },
  { value: "4", label: "Specialty Molecule lines" },
];

export const SHELFANOX = {
  brand: "Shelfanox",
  tagline: "Synthetic Antioxidants",
  blurb:
    "Food-grade synthetic antioxidants engineered for thermal stability, regulatory compliance and predictable performance across diverse matrices. The workhorses behind shelf life.",
};

export const SHELFANOX_PRODUCTS = [
  {
    code: "TBHQ",
    name: "Tert-Butylhydroquinone",
    cas: "1948-33-0",
    uses: ["Edible oils & fats", "Fried snacks", "Biodiesel stability"],
  },
  {
    code: "BHA",
    name: "Butylated Hydroxyanisole",
    cas: "25013-16-5",
    uses: ["Animal fats", "Confectionery", "Essential oils"],
  },
  {
    code: "BHT",
    name: "Butylated Hydroxytoluene",
    cas: "128-37-0",
    uses: ["Cereals", "Vegetable oils", "Cosmetic formulations"],
  },
  {
    code: "AP",
    name: "Ascorbyl Palmitate",
    cas: "137-66-6",
    uses: ["Infant nutrition", "Vitamin formulations", "Pharma actives"],
  },
];

export const SPECIALTY = {
  category: "Specialty Chemicals",
  blurb:
    "Phenolic intermediates and polymerisation inhibitors — supplied to fine-chemical, pharmaceutical and polymer manufacturers who need consistent, audited purity. Compliant for downstream pharmaceutical use where required.",
};

export const SPECIALTY_PRODUCTS = [
  {
    code: "MeHQ",
    name: "p-Methoxyphenol",
    cas: "150-76-5",
    application: "Polymer Inhibitor",
    uses: [
      "Acrylic & methacrylic monomer inhibition",
      "Resins, coatings & UV-curables",
      "Storage-stability of reactive monomers",
    ],
  },
  {
    code: "Guaiacol",
    name: "2-Methoxyphenol",
    cas: "90-05-1",
    application: "Pharma Intermediate",
    uses: [
      "Guaifenesin synthesis (expectorant)",
      "Vanillin & flavour intermediates",
      "Pharmaceutical APIs & fine chemicals",
    ],
  },
];

// Legacy alias — referenced by other sections that previously imported SYNTHETIC_PRODUCTS.
// Kept pointing to Shelfanox so industries / clean-chemistry copy stays accurate.
export const SYNTHETIC_PRODUCTS = SHELFANOX_PRODUCTS;

export const NATPRO = {
  brand: "NatPro",
  product: "Mixed Tocopherols",
  blurb:
    "A naturally-derived antioxidant blend of α, β, γ and δ tocopherols, distilled from non-GMO vegetable oil deodoriser distillates. Clean-label, GMO-free, allergen-free.",
  grades: ["NatPro 30", "NatPro 50", "NatPro 70", "NatPro 90"],
};

export const INDUSTRIES = [
  { name: "Food & Beverage", desc: "Edible oils, snacks, bakery, dairy fat blends." },
  { name: "Animal Feed", desc: "Poultry, aquaculture, pet nutrition shelf-life." },
  {
    name: "Pharmaceutical",
    desc: "Specialty intermediates (Guaiacol), API stabilisation, soft-gels.",
  },
  { name: "Cosmetics & Personal Care", desc: "Emollients, lipsticks, skin lipids." },
  { name: "Oils & Fats", desc: "Refined oils, lecithin and lipid stabilisation." },
  {
    name: "Biodiesel",
    desc: "FAME oxidation stability with Shelfanox antioxidants.",
  },
  {
    name: "Polymers & Plastics",
    desc: "Acrylic monomer inhibition with MeHQ, resins & coatings.",
  },
  { name: "Nutraceuticals", desc: "Omega-3, vitamin E premixes, gummies." },
];

export const CERTIFICATIONS = [
  "FSSC 22000",
  "ISO 9001:2015",
  "HALAL",
  "KOSHER",
  "FAMI-QS",
  "FSSAI",
  "REACH Pre-registered",
];

export const SUSTAINABILITY_POINTS = [
  {
    k: "01",
    title: "Zero Liquid Discharge",
    body:
      "Our facility runs on a fully closed-loop water system — 100% of process water is recovered, treated and reused. Not a single drop of effluent leaves the plant.",
  },
  {
    k: "02",
    title: "Process Engineering Excellence",
    body:
      "Closed-loop reactors, solvent recovery and continuous distillation make our Shelfanox antioxidants, NatPro tocopherols and Specialty Chemicals manufacturing efficient, waste-minimal and energy-aware.",
  },
  {
    k: "03",
    title: "NatPro Renewable Feedstock",
    body:
      "NatPro tocopherols are recovered from edible-oil deodoriser distillates — a circular use of an otherwise underutilised stream, distilled to preserve the natural isomers.",
  },
];

export const CONTACT = {
  email: "sales@milestonetbhq.org",
  phone: "+91 95120 04919",
  address: ["Milestone Preservatives Pvt. Ltd.", "Plot No. D-2/18/3, Dahej-2 Industrial Estate, GIDC Dahej- Tal. Vagra- Dist. ,Bharuch-392130 Gujarat"],
  hours: "Mon — Fri · 09:30 to 18:00 IST",
};
